import { Lock } from "lucide-react";

interface ToolCardProps {
  tool: {
    id: string;
    name: string;
    client?: string;
    thumbnail?: string;
    access_level: "visible" | "locked" | "hidden";
  };
  onClick: () => void;
}

export default function ToolCard({ tool, onClick }: ToolCardProps) {
  const isLocked = tool.access_level === "locked";

  return (
    <div
      onClick={!isLocked ? onClick : undefined}
      className={`relative bg-white border-2 border-black p-6 transition-all duration-300 flex-shrink-0 w-[450px] ${
        isLocked
          ? "cursor-not-allowed"
          : "cursor-pointer hover:-translate-y-1 hover:shadow-[8px_8px_0px_0px_rgba(0,0,0,1)]"
      }`}
      style={{ fontFamily: "'Courier New', monospace" }}
    >
      {/* Locked Overlay - Positioned at bottom */}
      {isLocked && (
        <div className="absolute inset-0 bg-gradient-to-t from-white via-white/40 to-transparent flex items-end justify-center pb-6 z-10">
          <div className="text-center bg-white border-4 border-black px-6 py-3 shadow-[8px_8px_0px_0px_rgba(0,0,0,1)]">
            <div className="flex items-center gap-2">
              <Lock className="w-5 h-5 text-black" />
              <p className="text-black font-bold text-sm uppercase">
                Locked - Request Access
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Thumbnail */}
      <div className="mb-4">
        <div className="text-6xl md:text-7xl">{tool.thumbnail || "📦"}</div>
      </div>

      {/* Tool Name */}
      <h3
        className="text-xl md:text-2xl font-bold text-black mb-2 truncate"
        title={tool.name}
      >
        {tool.name}
      </h3>

      {/* Client */}
      {tool.client && (
        <p className="text-sm text-gray-600 truncate" title={tool.client}>
          {tool.client}
        </p>
      )}

      {/* View CTA */}
      {!isLocked && (
        <div className="mt-4 pt-4 border-t-2 border-black">
          <p className="text-sm font-bold text-black uppercase">
            View Case Study →
          </p>
        </div>
      )}
    </div>
  );
}
